// Laghåndtering for verktøygrafikk — to feil som begge ga «ingenting skjedde».
//
// FEIL 1: LAGENE BLE ALDRI OPPRETTET.
// Måle-, akse- og ruteverktøyene la kilde og lag inne i `map.on('load')`. Er
// verktøyet konstruert ETTER at stilen er ferdig lastet, fyrer `load` aldri
// igjen, og lyttereren kjøres ikke. Da finnes ikke kilden, og `render()` med
// valgfri kjeding (`?.setData`) gjør ingenting — helt stille. Det er nøyaktig
// symptomet «Fremrykningsakse tegnet ingenting: ingen synlig strek, ingen pil,
// ingen indikasjon på at noe var tegnet». I dag ligger konstruksjonen tilfeldigvis
// før `load`, så feilen er latent — men den venter bare på at noen flytter en
// linje i main.ts.
//
// FEIL 2: LAGENE LÅ UNDER KARTETS EGNE LAG.
// Verktøylagene legges tidlig. Alt som legges SENERE havner over dem, og
// HV-kommuneflata (`hv-kom-fill`) er en fyllflate på 42 % rødt over eget område.
// En 2 px stiplet gullinje under den er praktisk talt usynlig. Operatøren tegner
// altså riktig, og ser ingenting.
//
// Verktøygrafikk er det operatøren aktivt HOLDER PÅ MED. Den skal alltid ligge
// øverst, uten unntak.
import type { Map as MlMap } from 'maplibre-gl';

/**
 * Kjør `fn` når kartstilen er klar — NÅ hvis den allerede er det.
 *
 * `map.on('load')` alene er en felle: den fyrer én gang, og har den fyrt før du
 * registrerte deg, får du aldri beskjed. `isStyleLoaded()` skiller de to
 * tilfellene.
 */
export function naarKartetErKlart(map: MlMap, fn: () => void): void {
  // `isStyleLoaded` kan mangle på et forenklet kart (testdobler). Da VET vi ikke
  // om stilen er klar, og det trygge svaret er å vente på `load` — ikke å kjøre
  // med en gang og risikere å legge lag inn i en stil som ikke finnes.
  const klar = typeof map.isStyleLoaded === 'function' ? map.isStyleLoaded() : false;
  if (klar) { fn(); return; }
  map.once?.('load', fn);
}

/**
 * Løft verktøylag til toppen, i den rekkefølgen de er oppgitt (siste øverst).
 *
 * `moveLayer(id)` uten `beforeId` flytter laget helt opp i MapLibre. Ukjente
 * id-er hoppes over: et verktøy skal kunne be om å bli løftet før laget finnes,
 * uten at kallet kaster midt i en `start()`.
 */
export function hevVerktoylag(map: MlMap, lagIder: readonly string[]): void {
  for (const id of lagIder) {
    if (!map.getLayer(id)) continue;
    try { map.moveLayer(id); } catch { /* stil byttes samtidig — neste start løfter igjen */ }
  }
}
